import { format, isToday, isTomorrow } from 'date-fns';

import type { Scan } from '../../api/generated/insights.schemas';

export type NotificationType = 'none' | 'can_retry' | 'cooldown' | 'exhausted';

export const getNotificationType = (failedScans: Scan[]): NotificationType => {
  if (failedScans.some((scan) => scan.canManualRetry)) {
    return 'can_retry';
  }
  if (failedScans.some((scan) => scan.manualRetryCount === 1 && !scan.canManualRetry && scan.nextManualRetryAfter != null)) {
    return 'cooldown';
  }
  if (failedScans.some((scan) => scan.manualRetryCount >= 2)) {
    return 'exhausted';
  }
  return 'none';
};

export const formatNextRetryDate = (isoString: string): string => {
  const date = new Date(isoString);
  const timeStr = format(date, 'h:mm a');

  if (isToday(date)) {
    return `today at ${timeStr}`;
  }
  if (isTomorrow(date)) {
    return `tomorrow at ${timeStr}`;
  }
  return `${format(date, 'MMM d')} at ${timeStr}`;
};

export const getEarliestNextRetryAfter = (failedScans: Scan[]): string | undefined =>
  failedScans
    .map((scan) => scan.nextManualRetryAfter)
    .filter((d): d is string => d != null)
    .sort()[0];

export const getDismissKey = (analysisId: string, notificationType: NotificationType): string =>
  `incomplete_analysis_dismissed_${analysisId}_${notificationType}`;
